import { LAYOUTS, } from '@voltmoney/types';
import { WIDGET } from "@voltmoney/schema";
import { ROUTE } from "../../routes";
import { ACTION } from "./types";
import { continueAction, helpAction, onLoad } from "./action";
import { getLenderInfo, showNewCongratsScreen } from "../../configs/utils";
export const template = async (height, lenderInfo, showDownloadAppScreen, showNewCongratsScreenForAll) => {
    return {
        layout: {
            id: ROUTE.CREDIT_LOADING_SCREEN,
            type: LAYOUTS.LIST,
            widgets: [
                showDownloadAppScreen ? { id: "creditDownload", type: WIDGET.CREDIT_LIMIT_DOWNLOAD } : { id: "creditLoanDC", type: WIDGET.CREDIT_LOADING_SCREEN },
            ],
        },
        datastore: {
            creditLoanDC: {
                height: height,
                showNewCongratsScreenForAll,
                helpAction: {
                    type: ACTION.HELP_ACTION,
                    routeId: ROUTE.CREDIT_LOADING_SCREEN,
                    payload: {}
                },
                continueAction: {
                    type: ACTION.CONTINUE_ACTION,
                    routeId: ROUTE.CREDIT_LOADING_SCREEN,
                    payload: { showDownloadAppScreen: false }
                },
                lenderData: lenderInfo
            },
            creditDownload: {
                height: height,
                helpAction: {
                    type: ACTION.HELP_ACTION,
                    routeId: ROUTE.CREDIT_LOADING_SCREEN,
                    payload: {}
                },
                continueAction: {
                    type: ACTION.CONTINUE_ACTION,
                    routeId: ROUTE.CREDIT_LOADING_SCREEN,
                    payload: { showDownloadAppScreen: showDownloadAppScreen }
                },
                lenderData: lenderInfo
            }
        },
    };
};
export const creditLoadingMF = {
    onLoad: async ({ getHeight, network }, { showDownloadAppScreen }) => {
        const lenderInfo = await getLenderInfo(network);
        const showNewCongratsScreenForAll = await showNewCongratsScreen();
        return Promise.resolve(template(getHeight(), lenderInfo, showDownloadAppScreen, showNewCongratsScreenForAll));
    },
    action: {
        type: ACTION.ON_LOAD,
        routeId: ROUTE.CREDIT_LOADING_SCREEN,
        payload: {}
    },
    actions: {
        [ACTION.HELP_ACTION]: helpAction,
        [ACTION.ON_LOAD]: onLoad,
        [ACTION.CONTINUE_ACTION]: continueAction,
    },
    clearPrevious: true,
};
